import {FullNameField} from './full-name-field';

export default FullNameField;